import { capitalize } from './stringHelpers';

const flattenObject = object => {
  const result = {};

  Object.keys(object).forEach(key => {
    if (typeof object[key] === 'object' && object[key] !== null && !Array.isArray(object[key])) {
      const flatObject = flattenObject(object[key]);
      Object.keys(flatObject).forEach(flatObjectKey => {
        result[`${key}${capitalize(flatObjectKey)}`] = flatObject[flatObjectKey];
      });
    } else {
      result[key] = object[key];
    }
  });

  return result;
};

const unFlattenObject = (ui, server, keys) => {
  const result = {};

  Object.keys(ui)
    .filter(key => keys.includes(key))
    .forEach(key => {
      if (typeof ui[key] === 'object' && ui[key] !== null && !Array.isArray(ui[key])) {
        const flatObject = flattenObject(ui[key]);
        Object.keys(flatObject).forEach(flatObjectKey => {
          const serverKey = `${key}${capitalize(flatObjectKey)}`;

          if (serverKey in server) {
            if (key in result) {
              result[key][flatObjectKey] = server[serverKey];
            } else {
              result[key] = {
                [flatObjectKey]: server[serverKey],
              };
            }
          }
        });
      } else if (key in server) {
        result[key] = server[key];
      }
    });

  return result;
};

export { flattenObject, unFlattenObject };
